import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";

import { createEffect, Actions, ofType } from "@ngrx/effects";
import * as RouterActions from "../actions/router.action";

import { tap, map } from "rxjs/operators";

@Injectable()
export class RouterEffects {
    constructor(
        private actions$: Actions,
        private router: Router,
        private location: Location
    ) {}

    
    navigate$ = createEffect(() => this.actions$.pipe(ofType(RouterActions.GO)).pipe(
        map((action: RouterActions.Go) => action.payload),
        tap(({ path, query: queryParams, extras }) => {
            this.router.navigate(path, { queryParams, ...extras });
        })
    ), { dispatch: false });

    
    navigateBack$ = createEffect(() => this.actions$
        .pipe(ofType(RouterActions.BACK))
        .pipe(tap(() => this.location.back())), { dispatch: false });

    
    navigateForward$ = createEffect(() => this.actions$
        .pipe(ofType(RouterActions.FORWARD))
        .pipe(tap(() => this.location.forward())), { dispatch: false });
}
